// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"612":"3b53517f","832":"7e3d3fa8"}[chunkId] + ".chunk.css";
};